import STORAGE_SECRET from "constants/STORAGE_SECRET";
import { enc, dec } from "utils/crypto";

export function get(key, set, defaultValue = null, options = {}) {
  const savedValue = localStorage.getItem(key);
  if (savedValue != null) {
    const parsedValue = JSON.parse(savedValue);
    const value = options.encryption ? dec(parsedValue, STORAGE_SECRET) : parsedValue;
    const typedValue = options.type !== 'string' ? JSON.parse(value) : value;
    return typedValue;
  } else {
    if (options.initial) set(key, defaultValue);
    return defaultValue;
  }
}

export function set(key, newValue, options) {
  const value = JSON.stringify(options.encryption ? enc(newValue, STORAGE_SECRET) : newValue);
  localStorage.setItem(key, value);
}

const localStorageEffect = (key, defaultValue, options) => ({ setSelf, onSet }) => {
  setSelf(get(key, set, defaultValue, options));
  onSet((newValue) => {
    const value = options.type !== 'string' ? JSON.stringify(newValue) : newValue;
    set(key, value, options);
  });
};

export default localStorageEffect;